"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var formik_1 = require("formik");
var react_1 = __importDefault(require("react"));
var Icons_1 = require("../Icons");
require("./Select.scss");
function Select(props) {
    var _a = formik_1.useField(props), field = _a[0], meta = _a[1];
    var isSubmitting = formik_1.useFormikContext().isSubmitting;
    var _b = props.className, className = _b === void 0 ? '' : _b, _c = props.width, width = _c === void 0 ? 'lg' : _c, dusk = props.dusk, options = props.options, _d = props.emptyLabel, emptyLabel = _d === void 0 ? '-- Select --' : _d, _e = props.withEmpty, withEmpty = _e === void 0 ? true : _e, _f = props.allowSubmittingDisabledState, allowSubmittingDisabledState = _f === void 0 ? true : _f, rest = __rest(props, ["className", "width", "dusk", "options", "emptyLabel", "withEmpty", "allowSubmittingDisabledState"]);
    var keys = Object.keys(options);
    return (react_1.default.createElement("div", { "data-dusk": dusk, className: classnames_1.default('form-select', className, {
            'form-select--error': !!meta.error,
            'form-select--w-xs': width === 'xs',
            'form-select--w-sm': width === 'sm',
            'form-select--w-md': width === 'md',
            'form-select--w-lg': width === 'lg',
        }) },
        react_1.default.createElement("select", __assign({}, field, { value: field.value || '', disabled: isSubmitting && allowSubmittingDisabledState }, rest),
            withEmpty && react_1.default.createElement("option", null, emptyLabel),
            keys.map(function (key) { return (react_1.default.createElement("option", { key: "opt-" + key, value: key }, options[key])); })),
        react_1.default.createElement("div", { className: "form-select__icon" },
            react_1.default.createElement(Icons_1.ChevronDown, null))));
}
exports.default = Select;
//# sourceMappingURL=index.js.map